const syncBuyNowForm = (form) => {
  const productDetails = form.closest('.product-details');
  const nativeForm = productDetails?.querySelector('product-form-component');
  const variantInput = nativeForm?.querySelector('input[name="id"]');
  const quantityInput = nativeForm?.querySelector('input[name="quantity"]');
  const buyNowVariant = form.querySelector('input[name="id"]');
  const buyNowQuantity = form.querySelector('input[name="quantity"]');

  if (variantInput?.value && buyNowVariant) buyNowVariant.value = variantInput.value;
  if (quantityInput?.value && buyNowQuantity) buyNowQuantity.value = quantityInput.value;
};

document.addEventListener('submit', (event) => {
  const form = event.target.closest?.('.sv-buy-now-form');
  if (!form) return;
  syncBuyNowForm(form);
});

document.addEventListener('change', (event) => {
  if (!event.target.closest?.('.sv-product-main')) return;

  requestAnimationFrame(() => {
    document.querySelectorAll('.sv-product-main .sv-buy-now-form').forEach(syncBuyNowForm);
  });
});
